import { useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { fetchAllVATCodes } from '~/api/bookkeeping/vat-codes';
import { useActiveCompanyId } from '~/hooks/useActiveCompany';
import { VATCode } from '~/types/vat-bookkeeping';

const VATCodeQueryKeys = {
  all: ['vat-codes'] as const,
  byCompany: (companyId: string) => ['vat-codes', companyId] as const,
};

export const useVATCodes = () => {
  const companyId = useActiveCompanyId();
  return useSuspenseQuery({
    queryKey: VATCodeQueryKeys.byCompany(companyId),
    queryFn: fetchAllVATCodes,
    staleTime: Infinity,
  });
};

export const useVATCodesQuery = () => {
  const companyId = useActiveCompanyId();
  return useQuery({
    queryKey: VATCodeQueryKeys.byCompany(companyId),
    queryFn: fetchAllVATCodes,
    staleTime: Infinity,
  });
};

export const useVATCodesById = () => {
  const companyId = useActiveCompanyId();
  return useSuspenseQuery({
    queryKey: VATCodeQueryKeys.byCompany(companyId),
    queryFn: fetchAllVATCodes,
    staleTime: Infinity,
    select: (codes: VATCode[]): Map<string, VATCode> => new Map(codes.map((code) => [code.id, code])),
  });
};
